module.exports = __webpack_public_path__ + "static/media/search.8812570e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/search.svg
// module id = 851
// module chunks = 0